import Invoice4Container from "../../../../../Components/Applications/ECommerce/Invoice/Invoice4/Invoice4Container";

const Invoice4 = () => {
  return <Invoice4Container />;
};

export default Invoice4;
